const ESC = "\x1B"; // ESC byte
const GS = "\x1D"; // GS byte
const FS = "\x1C"; // FS byte

const UTF8 = FS + '\x43' + "\xFF";

function utf8Enconde(str) {
  return str
    .split("")
    .map((char) => {
      const code = char.charCodeAt(0);
      if (code < 128) {
        return String.fromCharCode(code);
      } else if (code < 2048) {
        return String.fromCharCode((code >> 6) | 192, (code & 63) | 128);
      } else if (code < 65536) {
        return String.fromCharCode(
          (code >> 12) | 224,
          ((code >> 6) & 63) | 128,
          (code & 63) | 128
        );
      } else {
        return String.fromCharCode(
          (code >> 18) | 240,
          ((code >> 12) & 63) | 128,
          ((code >> 6) & 63) | 128,
          (code & 63) | 128
        );
      }
    })
    .join("");
}

export const ESCCommands = {
  initialize() {
    return ESC + "@"; // Initialize printer
  },

  text(txt) {
    return utf8Enconde(txt) + "\n"; // Text + line feed
  },

  bold(on) {
    return ESC + "E" + (on ? "\x01" : "\x00"); // Turn bold mode on/off
  },

  alignLeft() {
    return ESC + "a" + "\x00"; // Align left
  },

  alignCenter() {
    return ESC + "a" + "\x01"; // Align center
  },

  alignRight() {
    return ESC + "a" + "\x02"; // Align right
  },

  feed(n = 1) {
    return ESC + "d" + String.fromCharCode(n); // Feed n lines
  },

  cut() {
    return GS + "V" + "\x00"; // Full cut
  },

  partialCut() {
    return GS + "V" + "\x01"; // Partial cut
  },

  fontSize(size) {
    const fontSize = {
      small: 0,
      medium: 16 + 1,
      large: 32 + 2,
    };
    return GS + "!" + String.fromCharCode(fontSize[size]); // Set font size
  },

  setSinglebyte() {
    return ESC + "t" + "\x01"; // Set single-byte mode
  },
  setMultibyte() {
    return FS + '\x26'
  },
  setUTF8() {
    return ESCCommands.setMultibyte() + UTF8;
  },
  qrCode(data) {
    const storeQRCodeData = (data) => {
      const len = data.length + 3;
      const pL = len % 256;
      const pH = Math.floor(len / 256);
      return GS + "(k" + String.fromCharCode(pL, pH) + "\x31\x50\x30" + data;
    };

    const setQRCodeModel = () =>
      GS + "(k" + String.fromCharCode(3, 0) + "\x31\x41\x32"; // model 2
    // Set QR code size to maximum (16)
    const setQRCodeSize = () =>
      GS + "(k" + String.fromCharCode(3, 0) + "\x31\x43\x09"; // size 9 (1–16) (last byte is size)

    const setQRCodeError = () =>
      GS + "(k" + String.fromCharCode(3, 0) + "\x31\x45\x30"; // correction level L
    const printQRCode = () =>
      GS + "(k" + String.fromCharCode(3, 0) + "\x31\x51\x30"; // print

    return (
      setQRCodeModel() +
      setQRCodeSize() +
      setQRCodeError() +
      storeQRCodeData(data) +
      printQRCode()
    );
  },
};
